export type MapConfig = {
    isInteractive: boolean;
    showDrivers: boolean;
    showControls: boolean;
};

export function getMapConfig(isConfirmation?: boolean): MapConfig {
    return {
        isInteractive: !isConfirmation,
        showDrivers: !isConfirmation,
        showControls: true,
    };
}
